/* eslint-disable quotes */
import { snakelize, camelize } from '../../../helpers/object';
import {
  UploadGuideImageRequestParams,
  UploadGuideImageResponse,
} from './guide.types';

export default ($axios: any): any => ({
  /**
   * 가이드 이미지 업로드
   */
  async uploadGuideImage(
    data?: UploadGuideImageRequestParams,
  ): Promise<UploadGuideImageResponse> {
    const formData = new FormData();
    formData.append('image', data.image);
    formData.append('brand_token', data.brandToken);

    return camelize(await $axios.post('/guide/image/upload', formData));
  },

  // 가이드 목록
  async index(data?: any) {
    return camelize(await $axios.get(`/guide`, snakelize({ params: data })));
  },

  async store(data?: any) {
    const formData = new FormData();
    formData.append('images', data.images);
    formData.append('brand_token', data.brandToken);
    formData.append('is_default', data.isDefault);

    return camelize(await $axios.post('/guide', formData));
  },

  async uploadImage(data?: any) {
    const formData = new FormData();
    formData.append('image', data.image);
    formData.append('brand_token', data.brandToken);

    return camelize(await $axios.post('/guide/image/upload', formData));
  },

  async delete(data?: any) {
    return camelize(await $axios.delete(`/guide/${data.id}`));
  },
});
